import React, {useCallback, useRef, useState} from 'react';
import withStore from "@/hocs/withStore";
import {isDesktop} from "@/Helpers/Function";
import isEmpty from "is-empty";
import CardAll from "@/Pages/All/CardAll";
import Svg from "@/Pages/All/Svg";
import {Swiper, SwiperSlide} from "swiper/react";
import {Autoplay, EffectFade, Navigation, Pagination, Thumbs} from "swiper/modules";

const GarniturComponent = (props) => {
    const {product = {}, config = {}} = props;
    const {defaultImage = {}} = config;
    const {productsGarnitur = []} = product;

    const leftSwiperRef = useRef(null);
    const rightSwiperRef = useRef(null);
    const [swiper, setSwiper] = useState(null);

    const leftSwiperSettings = {
        // autoplay: true,
        loop: true,
        spaceBetween: 10,
        slidesPerView: productsGarnitur.length <= 3 ? productsGarnitur.length : 3,
        // freeMode: true,
        pagination: {
            clickable: true,
            dynamicBullets: true,
        },
        // navigation: true,
        className: 'garniturLeftSlider',
        modules: [Autoplay, Thumbs, Navigation, Pagination],
        // Responsive breakpoints
        breakpoints: {
            // when window width is >= 320px
            320: {
                slidesPerView: productsGarnitur.length <= 2 ? productsGarnitur.length : 2,
                pagination: {
                    clickable: true,
                    dynamicBullets: true,
                },
            },
            // when window width is >= 577px
            577: {
                slidesPerView: productsGarnitur.length <= 3 ? productsGarnitur.length : 3,
            },
            // when window width is >= 768px
            768: {
                slidesPerView: productsGarnitur.length <= 3 ? productsGarnitur.length : 3,
            },
            // when window width is >= 992px
            992: {
                slidesPerView: productsGarnitur.length <= 2 ? productsGarnitur.length : 2,
                pagination: false,
            },
            // when window width is >= 1200px
            1200: {
                slidesPerView: productsGarnitur.length <= 2 ? productsGarnitur.length : 2,
                pagination: false,
            },
            // when window width is >= 1366px
            1366: {
                slidesPerView: productsGarnitur.length <= 3 ? productsGarnitur.length : 3,
                pagination: false,
            },
        }
    };

    const rightSwiperSettings = {
        autoplay: true,
        loop: true,
        // effect: 'fade',
        spaceBetween: 10,
        // freeMode: true,
        // watchSlidesProgress: true,
        className: 'garniturRightSlider',
        modules: [Thumbs, Pagination, Autoplay, EffectFade],
    };

    const ArrowPrev = () => {
        let className = 'swiperNavigationContainer__arrow swiperNavigationContainer__arrow_left';

        const handlePrev = useCallback(() => {
            if (!rightSwiperRef.current) return;
            rightSwiperRef.current.swiper.slidePrev();
        }, []);

        return <div className={className} onClick={handlePrev}>
            <Svg id={`arrows-left`} className={`svg__swiperArrow`} />
        </div>
    }

    const ArrowNext = () => {
        let className = 'swiperNavigationContainer__arrow swiperNavigationContainer__arrow_right';

        const handleNext = useCallback(() => {
            if (!rightSwiperRef.current) return;
            rightSwiperRef.current.swiper.slideNext();
        }, []);

        return <div className={className} onClick={handleNext}>
            <Svg id={`arrows-right`} className={`svg__swiperArrow`} />
        </div>
    }

    const leftSliderElements = productsGarnitur.map((el) => {
        return <SwiperSlide key={el.id}><CardAll el={el} {...props} /></SwiperSlide>
    });

    const rightSliderElements = productsGarnitur.map((el) => {
        let image, imgWebp;
        if (!isEmpty(el.imgModel)) {
            image = el.imgModel.split(';')[0];
        } else {
            image = !isEmpty(el.imgBasic) ? el.imgBasic : defaultImage.detailedPath;
        }
        imgWebp = image;
        if (image.includes('png')) {
            imgWebp = image.replace('png', 'webp');
        }
        if (image.includes('jpg')) {
            imgWebp = image.replace('jpg', 'webp');
        }
        if (image.includes('jpeg')) {
            imgWebp = image.replace('jpeg', 'webp');
        }

        return <SwiperSlide key={el.id}>
            <picture>
                <source type={`image/webp`} srcSet={imgWebp} />
                <img src={image}
                     alt={el.h1 + ' ' + el.article}
                     title={el.h1 + ' ' + el.article}
                     loading={`lazy`}
                />
            </picture>
        </SwiperSlide>
    });

    if (productsGarnitur.length === 0) return null;

    return <div id={`product-set`} className={`product product__garniturContainer`}>
        <p className={`product__title`}>украшения из гарнитура</p>
        <div className={`product__garniturSliderContainer`}>
            <div
                className={`product__leftSliderContainer${rightSwiperRef?.current?.swiper.isLocked ? '' : ' notLocked'}`}>
                {/*<div className={`product__left-slider`}>*/}
                {/*</div>*/}
                <Swiper ref={leftSwiperRef}
                    // thumbs={{swiper: swiper}}
                        onSwiper={setSwiper}
                        {...leftSwiperSettings}
                >
                    {leftSliderElements}
                </Swiper>
                {rightSwiperRef.current !== null && rightSwiperRef.current.swiper !== null && !rightSwiperRef.current.swiper.isLocked && (
                    <>
                        <ArrowPrev />
                        <ArrowNext />
                    </>
                )}
            </div>
            {isDesktop() && (
                <div className={`product__rightSliderContainer`}>
                    {/*<div className={`product__right-slider`}>*/}
                    {/*</div>*/}
                    <Swiper ref={rightSwiperRef}
                        // onSwiper={setSwiper}
                            thumbs={{swiper: swiper}}
                            {...rightSwiperSettings}
                    >
                        {rightSliderElements}
                    </Swiper>
                </div>
            )}
        </div>
    </div>
}

export default withStore(GarniturComponent);
